import { useTranslation } from 'react-i18next';
import React from 'react';

import { DataTransacton } from '~/entities/schemas/dataTransaction';
import Loader from '~/components/Loader/Loader';

import styles from './Footer.module.scss';

interface FooterComponentProps {
  dataTransaction: DataTransacton | null;
  loadingDataTr: boolean;
}

export const FooterComponent: React.FC<FooterComponentProps> = ({ dataTransaction, loadingDataTr }) => {
  const { t } = useTranslation();
  return (
    <div className={styles['footer-area']}>
      <div>{t('footer:forMoreQuestions')}</div>
      <div className={styles['support-text']}>
        {loadingDataTr ? (
          <Loader />
        ) : (
          <a href="mailto:dbs.payment@evisacam.com">
            {dataTransaction?.application?.merchant?.name.toLowerCase().includes('impact')
              ? 'dbs.payment@evisacam.com'
              : 'support@dbs-africa.com'}
          </a>
        )}
      </div>
    </div>
  );
};
